import CX from 'classnames'
import React from 'react'
import CursorPaginatedTable from './CursorPaginatedTable'
import { CheckboxTable } from '../../../components/CheckboxTable'
import config from '../../../config'
import './Table.scss'

const PAGE_SIZE_OPTIONS = [10, 15, 30, 50, 100]
const getNoDataProps = () => ({ style: { color: 'black' } })

const Table = props =>
  React.createElement(
    'div',
    {
      className: CX({
        'listing-manager-table': props.onExpandedChange,
        'listing-manager-table-sticky-first': !props.onExpandedChange
      })
    },
    config.CURSOR_PAGINATED_LISTING_MANAGER()
      ? React.createElement(CursorPaginatedTable, {
          ...props,
          pageSizeOptions: PAGE_SIZE_OPTIONS,
          noDataText: 'No Listings Found',
          getNoDataProps
        })
      : React.createElement(CheckboxTable, {
          ...props,
          pageSizeOptions: PAGE_SIZE_OPTIONS,
          noDataText: 'No Listings Found',
          getNoDataProps
        })
  )
export default Table
